import useFlagEnabled from 'hooks/useFlagEnabled';
import { useAppSelector } from 'store';
import { selectIsBuyer, selectIsGetStartedComplete } from 'store/selectors/me/company';

// The Actions Dashboard is a retailer-only surface that replaces Get Started rather than
// sitting alongside it. Every surface that decides whether to show it — the sidebar link,
// the /overview route, and the post-login redirect — must agree, so the condition lives here
// once instead of being copied at each call site.
const useShowQuickActionsDashboard = (): boolean => {
  const flagEnabled = useFlagEnabled('quickActionsDashboard');
  const isBuyer = useAppSelector(selectIsBuyer);
  const isGetStartedComplete = useAppSelector(selectIsGetStartedComplete);

  return flagEnabled && isBuyer && isGetStartedComplete;
};

export default useShowQuickActionsDashboard;
